
// import {SET_SEARCH_QUERY, SET_MORE_SCROLL,SET_OFFSET,SET_LOADING,SET_BRAND_FILTER,SET_SORT_OPTION,SET_PRODUCT_FILTER,} from "./action"

// const initialState = {
//   searchQuery: "",
//   selectedBrands: [],
//   selectedProducts: [],
//   selectedOption: "",
 
//   loading: false,
//   offset: 0,
//   morescroll: true,
// };

// const reducer = (state = initialState, action) => {
//   switch (action.type) {
//     case SET_SEARCH_QUERY:
//       return { ...state, searchQuery: action.payload };
//     case SET_BRAND_FILTER:
//       return { ...state, selectedBrands: action.payload };
//     case SET_PRODUCT_FILTER:
//       return { ...state, selectedProducts: action.payload };
//     case SET_SORT_OPTION:
//       return { ...state, selectedOption: action.payload };
    
//     case SET_LOADING:
//       return { ...state, loading: action.payload };
//     case SET_OFFSET:
//       return { ...state, offset: action.payload };
//     case SET_MORE_SCROLL:
//       return { ...state, morescroll: action.payload };
//     default:
//       return state;
//   }
// };

// export default reducer;


import {
  SET_SEARCH_QUERY,
  SET_BRAND_FILTER,
  SET_PRODUCT_FILTER,
  SET_SORT_OPTION,
  SET_FILTERED_ITEMS,
  SET_LOADING,
  SET_OFFSET,
  SET_MORE_SCROLL,
} from "./constant";

const initialState = {
  searchQuery: "",
  selectedBrands: [],
  selectedProducts: [],
  selectedOption: "",
  filteredItemList: [],
  loading: false,
  offset: 0,
  morescroll: true,
};

const reducer = (state = initialState, action) => {
    console.log('product/reducer________', action);
  switch (action.type) {
    case SET_SEARCH_QUERY:
      return { ...state, searchQuery: action.payload };
    case SET_BRAND_FILTER:
      return { ...state, selectedBrands: action.payload };
    case SET_PRODUCT_FILTER:
      return { ...state, selectedProducts: action.payload };
    case SET_SORT_OPTION:
      return { ...state, selectedOption: action.payload };
    case SET_FILTERED_ITEMS:
      return { ...state, filteredItemList: action.payload };
    case SET_LOADING:
      return { ...state, loading: action.payload };
    case SET_OFFSET:
      return { ...state, offset: action.payload };
    case SET_MORE_SCROLL:
      return { ...state, morescroll: action.payload };
    default:
      return state;
  }
};

export default reducer;
